import { useCallback } from 'react';
import {
	useDeleteFieldDiaryNote,
	usePostFieldDiaryNote,
	useUpdateFieldDiaryNote,
} from '@practium/features/api';
import type { NoteFormData } from '../types';
import { toNoteEntry } from '../utils';

export interface UseFieldDiaryNotesProps {
	propId: string;
	forBinding?: string;
}

export const useFieldDiaryNotes = ({ propId, forBinding }: UseFieldDiaryNotesProps) => {
	const { mutateAsync: createNote } = usePostFieldDiaryNote({ forBinding });
	const { mutateAsync: updateNote } = useUpdateFieldDiaryNote({ forBinding });
	const { mutateAsync: removeNote, isPending: isDeleting } = useDeleteFieldDiaryNote({
		forBinding,
	});

	const saveNote = useCallback(
		async (form: NoteFormData, entryId?: string) => {
			const fields = { title: form.title.trim(), scheduledDate: form.date, content: form.note };
			const category = form.category.trim();
			const dto = entryId
				? await updateNote({ id: entryId, data: { ...fields, category } })
				: await createNote({ ...fields, propId, category: category || undefined });
			return toNoteEntry(dto);
		},
		[propId, createNote, updateNote]
	);

	const deleteNote = useCallback((entryId: string) => removeNote(entryId), [removeNote]);

	return { saveNote, deleteNote, isDeleting };
};
